import { Box, Grid, MenuItem, Select, TextField, Stack, Button } from '@mui/material';
import React, { useState, useEffect } from 'react'
import { ErrorTypography, SecondaryTypography, StyledTypography } from '../../Theme';
import { ReactComponent as ContactDetailsIcon } from "../../Icons/ContactDetails.svg";
import { NameRegex, No_special_regex } from '../../Utils';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axiosInstance from '../../Redux/AxiosInstance';
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import PhoneInput from 'react-phone-input-2';

function AddOrganization() {

    const navigate = useNavigate()
    const { userDetails } = useSelector((state) => state.Login);
    console.log(userDetails)
    const initialDeviceData = {
        name: "",
        email: "",
        phone: "",
        address: "",
        company_name : "",
        level : "",
        unit : ""        
    }
    const [PersonalDetailsData, setPersonalDetailsData] = useState({
        ...initialDeviceData
      });

      const {id} = useParams();
      const location = useLocation();
      const {deviceData} = location.state || {};

      useEffect(() => {
        if(id && deviceData){
            setPersonalDetailsData({
                name: deviceData.name || "",
                company_name : deviceData.company_name || "",
                level : deviceData.level || "",
                unit : deviceData.unit || "",
                email: deviceData.email || "",
                phone: deviceData.phone || "",
                address: deviceData.address || "",
            });
        }
      }, [id, deviceData]);

      console.log(PersonalDetailsData)


      const [loading, setLoading] = useState(false)
      const [listBuilding, setListBuilding] = useState([])
      const [deviceList, setDeviceList] = useState([])

      // const deviceList = [
      //     {
      //         id : 1,
      //         name : 'Facial Recognition (FR) & Quick Response (QR)',
      //     },
      //     {
      //         id : 3,
      //         name : 'Automatic Number Plate Recognition (ANPR)',
      //     }
      // ]

      const [errtext, seterrtext] = useState({
        PersonalDetailsData: {...initialDeviceData},
      });

      console.log(errtext, 'err')
      const getAllVisitors = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}all_list_building`)
          console.log(response)
          if(response.status === 200){
            setListBuilding(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          console.log(error, 'list devices')
          setLoading(false);
      }
  }

      const getDeviceTypes = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}list_camera_type`)
          console.log(response)
          if(response.status === 200){
            setDeviceList(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          console.log(error, 'list devices')
          setLoading(false);
      }
  }
  
    // useEffect(() => {
    //   getAllVisitors();
    //   getDeviceTypes()
    // }, []);


     const handlePersonalDetails = (e, name) => {
  if (name) {
    // case for components like DatePicker or Select
    if(name == "phone"){
      console.log(e)
setPersonalDetailsData((prev) => ({
      ...prev,
      [name]: `+${e}`,
}))
    }else{
setPersonalDetailsData((prev) => ({
      ...prev,
      [name]: e,
    }));
    }
    

    seterrtext((prev) => ({
      ...prev,
      PersonalDetailsData: {
        ...prev.PersonalDetailsData,
        [name]: e ? "" : "This field is required",
      },
    }));
  } else {
    const { name, value } = e.target;

    setPersonalDetailsData((prev) => ({
      ...prev,
      [name]: value,
    }));

    seterrtext((prev) => ({
      ...prev,
      PersonalDetailsData: {
        ...prev.PersonalDetailsData,
        [name]: value.trim() === "" ? "This field is required" : "",
      },
    }));
  }
};


const validatePersonalDetails = () => {
  const newErrors = {};

  if (!PersonalDetailsData.name.trim()) {
    newErrors.name = "Host Name is required";
  } else if (PersonalDetailsData.name.length > 70) {
  newErrors.name = "Host Name must be 70 characters or less";
}
  if (!PersonalDetailsData.company_name.trim()) {
    newErrors.company_name = "Organization Name is required";
  } else if (PersonalDetailsData.company_name.length > 70) {
  newErrors.company_name = "Organization Name must be 70 characters or less";
}

  if (!PersonalDetailsData.address.trim()) {
    newErrors.address = "Address is required";
  } else if (PersonalDetailsData.address.length > 200) {
    newErrors.address = "Address must be 200 characters or less";
  }

  if (!PersonalDetailsData.email.trim()) {
    newErrors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(PersonalDetailsData.email)) {
    newErrors.email = "Enter a valid email";
  }

  if (!PersonalDetailsData.phone.trim()) {
  newErrors.phone = "Phone number is required";
} 

// else if (!/^\+65\d{8}$/.test(PersonalDetailsData.phone)) {
//   newErrors.phone = "Enter a valid Singapore number (e.g. +65XXXXXXXX)";
// }

  // Update the error state
  seterrtext((prev) => ({
    ...prev,
    PersonalDetailsData: {
      ...prev.PersonalDetailsData,
      ...newErrors,
    },
  }));

  // If no errors, return true
  return Object.keys(newErrors).length === 0;
};

      const saveDevice = async () => {
         if (validatePersonalDetails()) {
         
          setLoading(true)
          if(id){
             try {
              const response = await axiosInstance.put(`${process.env.REACT_APP_API_URL}company_update/${id}?updater_email=${userDetails?.email}`, {
                  // ...PersonalDetailsData,
                  name: PersonalDetailsData.name,
        email: PersonalDetailsData.email,
        phone: PersonalDetailsData.phone.length > 3 ? PersonalDetailsData.phone : "",
        address: PersonalDetailsData.address,
        company_name : PersonalDetailsData.company_name,
        level : PersonalDetailsData.level,
        unit : PersonalDetailsData.unit,
                  created_by : userDetails.id,
                  role_id : 5,
                  create_role : userDetails.user_role
              })
              console.log(response)
              if(response?.data?.status === 200){
                  console.log('created')
                  toast.success("Organization Updated Successfully")
                  setTimeout(() => {
                      navigate('/create_organization')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              console.log(error.response, 'saveDevice')
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          } else {
             try {
              const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}company_create?creator_email=${userDetails?.email}`, {
                  // ...PersonalDetailsData,
                  name: PersonalDetailsData.name,
        email: PersonalDetailsData.email,
        phone: PersonalDetailsData.phone.length > 3 ? PersonalDetailsData.phone : "",
        address: PersonalDetailsData.address,
        company_name : PersonalDetailsData.company_name,
        level : PersonalDetailsData.level,
        unit : PersonalDetailsData.unit,        
                  created_by : userDetails.id,
                  role_id : 5,
                  create_role : userDetails.user_role
              })
              console.log(response)
              if(response?.data?.status === 201){
                  console.log('created')
                  toast.success("Organization Created Successfully")
                  setTimeout(() => {
                      navigate('/create_organization')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              console.log(error.response, 'saveDevice')
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          }
         }
      }


  return (
      <>
      <ToastContainer
                  autoClose='3000'
                  position="bottom-center"
                  toastClassName="custom-toast"
                  hideProgressBar={true}
                />
    <Box
          mt={3}
          component="div"
        //   boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px"
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>Organization Details</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0 0 8px 8px  ",
            }}
          >
            <Grid xs={12} sm={5.8}>
              <StyledTypography>Organization Name</StyledTypography>
              <TextField
                name="company_name"
                value={PersonalDetailsData.company_name}
                onChange={handlePersonalDetails}
                disabled={id ? true : false}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 100 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.company_name
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.company_name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.company_name}
              </ErrorTypography>
            </Grid>
            <Grid xs={12} sm={5.8}>
              <StyledTypography>Host Name</StyledTypography>
              <TextField
                name="name"
                value={PersonalDetailsData.name}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 70 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.name
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.name}
              </ErrorTypography>
            </Grid>

             <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Level</StyledTypography>
              <TextField
                name="level"
                value={PersonalDetailsData.level}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 70 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.level
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.level
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.level}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Unit</StyledTypography>
              <TextField
                name="unit"
                value={PersonalDetailsData.unit}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 70 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.unit
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.unit
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.unit}
              </ErrorTypography>
            </Grid>


            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Email</StyledTypography>
              <TextField
                name="email"
                value={PersonalDetailsData.email}
                onChange={handlePersonalDetails}
                disabled={id ? true : false}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 70 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.email
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.email
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.email}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Phone</StyledTypography>
              {/* <TextField
                name="phone"
                value={PersonalDetailsData.phone}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.phone
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.phone
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
              /> */}
              <Box sx={{mt: 1}}>
               <PhoneInput
                                    value={PersonalDetailsData.phone}
                                    // onChange={(value, country, e) =>
                                    //   handleMobileInput(
                                    //     value,
                                    //     country,
                                    //     setPersonalDetailsData,
                                    //     PersonalDetailsData,
                                    //     "PersonalDetailsData"
                                    //   )
                                    // }
                                    
                                    onChange={(e) => handlePersonalDetails(e, "phone")}
                                    inputProps={{  maxLength: 20 }}
                                    country={"sg"}
                                    buttonStyle={{ border: "none" }}
                                    inputStyle={{
                                      backgroundColor: errtext.PersonalDetailsData.phone
                                        ? "#FEE4E2"
                                        : " #F9FAFB",
                                      border: "none",
                                      height: "46px",
                                      width: "100%",
                                      marginTop : "8px",
                                      borderRadius: "8px",
                                      color: errtext.PersonalDetailsData.phone
                                        ? "#912018"
                                        : "#111927",
                                    }}
                                    countryCodeEditable={false}
                                    placeholder=""
                                    specialLabel="" 
                                  />
                                  </Box>
              <ErrorTypography>
                {errtext.PersonalDetailsData.phone}
              </ErrorTypography>
            </Grid>

            

           

            <Grid xs={12} sm={12} mt={2}>
              <StyledTypography>
                Address
              </StyledTypography>
              <TextField
                name="address"
                value={PersonalDetailsData.address}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !No_special_regex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 100 }}
                multiline
                rows={3}
                InputProps={{ disableUnderline: true }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.address
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.address
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.address}
              </ErrorTypography>
            </Grid>



              {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Device Placement</StyledTypography>
              <Select
                name="device_placement"
                value={PersonalDetailsData.device_placement}
                onChange={(e) => handlePersonalDetails(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.device_placement
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.device_placement
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                <MenuItem value={`in`}>{`In`}</MenuItem>
                <MenuItem value={`out`}>{`Out`}</MenuItem>
                {/* {listBuilding.map((itm) => {
                  return <MenuItem value={itm.id}>{itm.building_name}</MenuItem>;
                })}
              </Select>
              <ErrorTypography>
                {errtext.PersonalDetailsData.device_placement}
              </ErrorTypography>
            </Grid> */}

            {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Device Type</StyledTypography>
              <Select
                name="type"
                value={PersonalDetailsData.type}
                onChange={(e) => handlePersonalDetails(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.type
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.type
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {deviceList.map((itm) => {
                  return <MenuItem value={itm.id}>{itm.title}</MenuItem>;
                })}
              </Select>
              <ErrorTypography>
                {errtext.PersonalDetailsData.type}
              </ErrorTypography>
            </Grid> */}

            {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Port</StyledTypography>
              <TextField
                name="port"
                value={PersonalDetailsData.port}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.port}
              </ErrorTypography>
            </Grid> */}

          
            
           
          </Grid>

            <Box bgcolor="#FFFFFF" sx={{ border: "1px solid #E5E7EB", borderRadius: '8px 8px 8px 8px', mt : 2 }}>
                <Stack direction="column" justifyContent='end' alignItems='end' sx={{ py : 2, px : 2, display: 'flex', gap : 2 , flexDirection : { xs : 'column', sm : 'row'} }}>
                    <Button type='button' onClick={() => navigate(-1)} sx={{ fontWeight: '600', width: "100px", color: '#800000', backgroundColor: "#f3eae7ff" }}>Back</Button>
                    <Button type='button' disabled={loading} onClick={() => saveDevice()} sx={{ fontWeight: '600', width: "100px", color: 'white', backgroundColor: "#800000" }}>{id ? "Update" : "Create"}</Button>
                </Stack>
            </Box>
        </Box>
        </>
  )
}

export default AddOrganization